import { BaseContainerModel } from '../base-container.model';
import { bl_hc_consultation_prescription_medicine_link_RowClass, bl_hc_consultation_prescription_medicine_link_RowInterface } from '../../dbschema/bl_hc_consultation_prescription_medicine_link.model';


export class HcConsultationPrescriptionMedicineLinkContainerModel extends BaseContainerModel {
  bl_hc_consultation_prescription_medicine_link: bl_hc_consultation_prescription_medicine_link_RowInterface = new bl_hc_consultation_prescription_medicine_link_RowClass();
}